// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const PlayStore: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="108" height="32">
            <defs>
                <path id="a" d="M0 0h108v32H0z" />
            </defs>
            <defs>
                <use xlinkHref="#a" />
                <use xlinkHref="#a" id="c" />
                <path id="e" d="M0 32h108V0H0z" />
            </defs>
            <g fill="none" fillRule="evenodd">
                <g>
                    <mask id="b" fill="#fff">
                        <use xlinkHref="#a" />
                    </mask>
                    <path
                        fill="#000"
                        d="M104 32H4c-2.24 0-4-1.76-4-4V4c0-2.24 1.84-4 4-4h100c2.24 0 4 1.76 4 4v24c0 2.24-1.84 4-4 4"
                        mask="url(#b)"
                    />
                </g>
                <g>
                    <mask id="d" fill="#fff">
                        <use xlinkHref="#c" />
                    </mask>
                    <path
                        fill="#A6A6A6"
                        d="M104 0H4C1.76 0 0 1.76 0 4v24c0 2.24 1.84 4 4 4h100c2.24 0 4-1.76 4-4V4c0-2.16-1.84-4-4-4Zm0 .64c1.84 0 3.36 1.52 3.36 3.36v24c0 1.84-1.52 3.36-3.36 3.36H4C2.16 31.36.64 29.84.64 28V4C.64 2.16 2.16.64 4 .64h100Z"
                        mask="url(#d)"
                    />
                </g>
                <path
                    fill="#FFF"
                    d="M37.929 7.787h-2.474v.737h1.733c-.06.405-.231.73-.511.966-.301.254-.684.383-1.142.383a1.74 1.74 0 0 1-1.27-.52c-.341-.349-.514-.792-.514-1.318 0-.525.173-.969.513-1.317.345-.345.773-.52 1.271-.52.256 0 .5.049.723.144.223.096.405.23.543.396l.055.069.56-.558-.05-.056a2.093 2.093 0 0 0-.802-.551 2.76 2.76 0 0 0-1.029-.193c-.715 0-1.33.25-1.826.746s-.747 1.115-.747 1.84c0 .726.251 1.344.747 1.84a2.497 2.497 0 0 0 1.826.748c.748 0 1.36-.248 1.82-.734.41-.412.62-.97.62-1.659a2.14 2.14 0 0 0-.035-.377l-.011-.066ZM38.566 10.515h2.962v-.75h-2.185V8.403h1.97v-.736h-1.97V6.306h2.185v-.751h-2.962zM41.878 6.305h1.34v4.21h.777v-4.21h1.341v-.75h-3.458z"
                />
                <mask id="f" fill="#fff">
                    <use xlinkHref="#e" />
                </mask>
                <path
                    fill="#FFF"
                    d="M47.295 10.516h.776v-4.96h-.776zM48.555 6.305h1.34v4.21h.777v-4.21h1.341v-.75h-3.458zM56.15 9.872c-.498 0-.92-.174-1.256-.518-.332-.345-.501-.788-.501-1.319 0-.53.169-.974.5-1.318a1.694 1.694 0 0 1 1.257-.518c.498 0 .919.173 1.25.519.336.34.507.784.507 1.317 0 .534-.17.978-.508 1.32a1.67 1.67 0 0 1-1.25.517m0-4.424c-.715 0-1.326.252-1.812.747-.487.493-.734 1.111-.734 1.84 0 .729.247 1.349.734 1.84.486.496 1.097.748 1.813.748.71 0 1.32-.252 1.813-.748.487-.491.734-1.111.734-1.84 0-.724-.247-1.341-.734-1.832-.486-.501-1.096-.755-1.813-.755M62.351 5.555v2.891l.02.677-2.228-3.568h-.875v4.96h.776V7.443l-.019-.674 2.311 3.709.024.037h.768v-4.96zM85.52 24h1.52V14h-1.52v10Zm13.44-6.4-1.68 4.32h-.08l-1.76-4.32h-1.6l2.64 6.08-1.52 3.36h1.52l4.08-9.44h-1.6Zm-8.48 5.28c-.48 0-1.2-.24-1.2-.88 0-.8.88-1.04 1.6-1.04.64 0 .96.16 1.36.32-.08.96-.88 1.6-1.76 1.6Zm.16-5.44c-1.12 0-2.24.48-2.64 1.52l1.36.56c.32-.56.8-.72 1.36-.72.8 0 1.52.48 1.6 1.28v.08c-.24-.16-.88-.4-1.52-.4-1.44 0-2.88.8-2.88 2.24 0 1.36 1.2 2.24 2.48 2.24 1.04 0 1.52-.48 1.92-.96h.08v.8h1.44v-3.84c-.16-1.84-1.44-2.8-3.2-2.8Zm-9.2 1.44h-2.16v-3.44h2.16c1.12 0 1.76.96 1.76 1.68 0 .8-.64 1.76-1.76 1.76Zm0-4.88h-3.6v10h1.52v-3.76h2.08c1.68 0 3.28-1.2 3.28-3.12 0-1.92-1.68-3.12-3.28-3.12Zm-19.52 8.88C60.88 22.88 60 22 60 20.8c0-1.2.88-2.08 1.92-2.08s1.84.88 1.84 2.08c-.08 1.2-.88 2.08-1.84 2.08Zm1.68-4.72c-.4-.4-1.04-.8-1.84-.8-1.68 0-3.28 1.52-3.28 3.44s1.52 3.36 3.28 3.36c.8 0 1.44-.4 1.76-.8h.08v.48c0 1.28-.72 2-1.84 2-.88 0-1.52-.64-1.68-1.2l-1.28.56c.4.88 1.36 2 3.04 2 1.76 0 3.2-1.04 3.2-3.52V17.6H63.6v.56ZM66.08 24h1.52V14h-1.52v10Zm3.68-3.28c0-1.28 1.04-2 1.76-2 .56 0 1.12.32 1.28.72l-3.04 1.28Zm4.64-1.12c-.32-.8-1.12-2.16-2.88-2.16-1.76 0-3.2 1.36-3.2 3.44 0 1.92 1.44 3.44 3.36 3.44 1.52 0 2.48-.96 2.8-1.52l-1.12-.8c-.4.56-.88.96-1.68.96-.8 0-1.28-.32-1.68-1.04L74.56 20l-.16-.4Zm-36.24-1.12v1.44h3.44c-.08.8-.4 1.44-.8 1.84-.48.48-1.28 1.04-2.64 1.04-2.16 0-3.76-1.68-3.76-3.84s1.68-3.84 3.76-3.84c1.12 0 2 .48 2.64 1.04l1.04-1.04c-.88-.8-2-1.44-3.6-1.44-2.88 0-5.36 2.4-5.36 5.28 0 2.88 2.48 5.28 5.36 5.28 1.6 0 2.72-.48 3.68-1.52.96-.96 1.28-2.32 1.28-3.36 0-.32 0-.64-.08-.88h-4.96Zm8.88 4.4c-1.04 0-1.92-.88-1.92-2.08 0-1.2.88-2.08 1.92-2.08s1.92.8 1.92 2.08-.88 2.08-1.92 2.08Zm0-5.44c-1.92 0-3.44 1.44-3.44 3.44 0 1.92 1.52 3.44 3.44 3.44s3.44-1.44 3.44-3.44c-.08-2-1.6-3.44-3.44-3.44Zm7.44 5.44c-1.04 0-1.92-.88-1.92-2.08 0-1.2.88-2.08 1.92-2.08s1.92.8 1.92 2.08-.88 2.08-1.92 2.08Zm0-5.44c-1.92 0-3.44 1.44-3.44 3.44 0 1.92 1.52 3.44 3.44 3.44s3.44-1.44 3.44-3.44-1.6-3.44-3.44-3.44Z"
                    mask="url(#f)"
                />
                <path
                    fill="#EA4335"
                    d="m16.477 15.482-8.48 9.04c.24.96 1.12 1.68 2.24 1.68.4 0 .8-.08 1.2-.32l9.6-5.52-4.56-4.88Z"
                    mask="url(#f)"
                />
                <path
                    fill="#FBBC04"
                    d="m25.12 14-4.16-2.4-4.64 4.16 4.64 4.64 4.08-2.4c.72-.4 1.2-1.12 1.2-2 .08-.8-.4-1.6-1.12-2"
                    mask="url(#f)"
                />
                <path
                    fill="#4285F4"
                    d="M7.957 7.338c-.081.161-.081.402-.081.563v16.063c0 .24 0 .402.08.563l8.835-8.836-8.834-8.353Z"
                    mask="url(#f)"
                />
                <path
                    fill="#34A853"
                    d="m16.56 16 4.4-4.4-9.6-5.52c-.32-.24-.72-.32-1.2-.32-1.04 0-2 .72-2.24 1.68L16.56 16Z"
                    mask="url(#f)"
                />
            </g>
        </svg>
    );
};

export default React.memo(PlayStore);
